import { render, staticRenderFns } from "./diseaseInfo.vue?vue&type=template&id=b1bd93ee&scoped=true"
import script from "./diseaseInfo.vue?vue&type=script&lang=js"
export * from "./diseaseInfo.vue?vue&type=script&lang=js"
import style0 from "./diseaseInfo.vue?vue&type=style&index=0&id=b1bd93ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.96.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1bd93ee",
  null
  
)

export default component.exports